/* src/app/private/components/leads/lead-profile/lead-profile.component.scss */
.avatar-url {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 50%;
  border-width: 6px;
  border-color: var(--primary-color);
}
.bottom-buttons {
  background-color: var(--p-card-background);
  width: 93%;
  bottom: 0px;
  border-bottom-right-radius: 5px;
  padding-bottom: 10px;
  padding-top: 10px;
}
.action-icon {
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  gap: 5px;
  background-color: var(--secondry-light-gray);
  border-radius: 50%;
  padding: 5px;
  height: 26px;
  width: 26px;
  font-weight: 600;
}
.action-icon i {
  font-size: 12px !important;
}
.divider {
  color: var(--secondry-dark-gray);
}
.profile-select {
  background-color: var(--secondry-light-gray) !important;
  border: none !important;
}
.profile-container {
  overflow-x: auto;
  overflow-y: hidden;
  height: 92vh;
}
::ng-deep .custom-confirm-dialog.p-dialog {
  max-width: 60vw !important;
  width: 60vw !important;
  border-radius: 1rem !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
  overflow: visible !important;
}
::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-content {
  padding: 0 !important;
  background: transparent !important;
  overflow: visible !important;
  border-radius: 1rem !important;
}
::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-header {
  display: none !important;
}
::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-footer {
  display: none !important;
}
@keyframes bounce-in {
  0% {
    transform: scale(0) translateY(20px);
    opacity: 0;
  }
  50% {
    transform: scale(1.1) translateY(0);
  }
  100% {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}
::ng-deep .animate-bounce-in {
  animation: bounce-in 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
/*# sourceMappingURL=lead-profile.component.css.map */
